// @ts-check
/**
 * Local storage service
 */
export default class StorageService {
  /**
   * Class constructor method
   * @param {Storage} storageEngine
   */
  constructor(storageEngine) {
    /**
     * Check if Storage is enabled
     */
    if (typeof Storage === 'undefined') {
      throw new Error('Local and Session Storage are not supported in your browser');
    }
    /**
     * Possible values are localStorage and sessionStorage
     * @type {Storage}
     */
    this.storageEngine = storageEngine;
  }

  /**
   * Set key in storage
   * @param key
   * @param {string | object} data
   */
  set(key = '', data = '') {
    let keyData = data;
    if (data && typeof data === 'object') {
      keyData = JSON.stringify(data);
    }
    this.storageEngine.setItem(key, keyData);
  }

  /**
   * Get data from storage
   * @param key
   */
  get(key = '') {
    let storageItem = this.storageEngine.getItem(key);
    try {
      return JSON.parse(storageItem);
    } catch (e) {
      return storageItem;
    }
  }

  /**
   * Remove item from storage
   * @param key
   */
  remove(key = '') {
    this.storageEngine.removeItem(key);
  }

  /**
   * Get key name by index
   * @param index
   */
  getKeyByIndex(index) {
    return this.storageEngine.key(index);
  }

  /**
   * Clear storage
   */
  clearStorage() {
    this.storageEngine.clear();
  }

  /**
   * Get length of storage
   * @returns {number}
   */
  length() {
    return this.storageEngine.length;
  }
}
